/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamTeacherMonitorDropdown200,
  GetApiV1ExamTeacherMonitorDropdown400,
  GetApiV1ExamTeacherMonitorDropdown401,
  GetApiV1ExamTeacherMonitorDropdown500,
  GetApiV1ExamTeacherMonitorDropdownQueryParams,
  GetApiV1ExamTeacherMonitorDropdownQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamTeacherMonitorDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamTeacherMonitorDropdownQueryParamsSchema = z
  .object({
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamTeacherMonitorDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdown200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamTeacherMonitorDropdown400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdown400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamTeacherMonitorDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamTeacherMonitorDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdown500>;

export const getApiV1ExamTeacherMonitorDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamTeacherMonitorDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamTeacherMonitorDropdownQueryResponse>;
